function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScShare = function SvgScShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "M7.876 10.638a2.62 2.62 0 0 0-2.251-1.285C4.175 9.353 3 10.538 3 12c0 1.462 1.175 2.647 2.625 2.647a2.62 2.62 0 0 0 2.251-1.285m0-2.724c.238.398.374.864.374 1.362 0 .498-.136.964-.374 1.362m0-2.724 5.998-3.629m-5.998 6.353 5.998 3.629m0 0a2.652 2.652 0 0 0-.374 1.362c0 1.462 1.175 2.647 2.625 2.647s2.625-1.185 2.625-2.647c0-1.462-1.175-2.647-2.625-2.647a2.62 2.62 0 0 0-2.251 1.285Zm0-9.982a2.62 2.62 0 0 0 2.251 1.285c1.45 0 2.625-1.185 2.625-2.647C18.75 4.185 17.575 3 16.125 3S13.5 4.185 13.5 5.647c0 .498.136.964.374 1.362Z",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScShare;